<div class="loading-progress" *ngIf="active">
  <div class="lp-header">
    <span class="lp-title">{{ title }}</span>
  </div>

  <div class="lp-track">
    <div class="lp-fill" [style.width.%]="progress"></div>
  </div>

  <div class="lp-message">{{ currentMessage }}</div>

  <div class="lp-hint" *ngIf="hint">{{ hint }}</div>
</div>
